/* LEMA: CONFIG */

var tamaro;

window.addEventListener('load',function () {
    var container = $('#lema-widget-container');

    if (container.length) {
        tamaro = container.data('lema');
        var redirect = $('.lema-redirect');
        window.rnwWidget = window.rnwWidget || {};
        window.rnwWidget.configureWidget = window.rnwWidget.configureWidget || [];

        window.rnw.tamaro.events["paymentComplete"].subscribe(function (event) {
            if (rnw.tamaro.instance.getTransactionFinalStatus() === 'success') {
                redirect.find('.name').val(rnw.tamaro.instance.transactionInfo.stored_customer_firstname + ' ' + rnw.tamaro.instance.transactionInfo.stored_customer_lastname);
                redirect.find('.gender').val(rnw.tamaro.instance.transactionInfo.stored_customer_salutation);
                redirect.find('.amount').val(rnw.tamaro.instance.transactionInfo.amount);
                redirect.find('.pdflink').val(rnw.tamaro.instance.transactionInfo.chqr_pdflink);
                redirect.find('.purposeUid').val(tamaro.uid);
                redirect.find('.submit').trigger('click');
            }
        });
        window.rnw.tamaro.events["purposeChanged"].subscribe(function (event) {
            var purpose = rnw.tamaro.instance.paymentForm.data.purpose;
            var record =  tamaro.records[purpose];
            if(record) {
                update_values(
                    event,
                    record['purpose'],
                    record['purpose'],
                    record['campaignSubid'],
                    record['campaignSubid']
                );
            }
        });

        function update_values(event, purpose, campaignId, campaignSubid, sxtProductId, sxtTemplateId) {
            rnw.tamaro.instance.paymentForm.data.es_message = purpose; // event.data.api
            rnw.tamaro.instance.paymentForm.data.stored_rnw_purpose_text = purpose;
            rnw.tamaro.instance.paymentForm.data.stored_sxt_product_id =  sxtProductId;
            rnw.tamaro.instance.paymentForm.data.stored_sxt_template_id = sxtTemplateId;
        }

        if (!redirect.length && !tamaro.useGtm){


            // GOOGLE ANALYTICS CONFIG
            var amount, purpose, paymentMethod, donationType, instanceName;
            var interval = "einmalig";

            window.rnw.tamaro.events["afterLoad"].subscribe(function (event) {
                for (i in rnwWidget.widgets.instances) {
                    if (rnwWidget.widgets.instances.hasOwnProperty(i)) {
                        var instanceName = i;
                        break;
                    }
                }
                dataLayer.push({
                    'event': 'checkout',
                    'ecommerce': {
                        'currencyCode': 'CHF',
                        'checkout': {
                            'actionField': {'step': 1},
                            'products': [{
                                'name': event.widget.widgetName,
                                'id': event.widget.id,
                                'brand': event.widget.widgetUUID,
                                'category': '',
                                'variant': '',
                                'price': '',
                                'quantity': 1,
                                'coupon': '',
                                'position': '',
                                'dimension1': rnwWidget.widgets.instances[instanceName].get("stored_rnw_product_version")
                            }]
                        }
                    }
                });
                checkout2();
            });

            function checkout2() {
                var change = 0;
                var formChange = function (event) {
                    for (i in rnwWidget.widgets.instances) {
                        if (rnwWidget.widgets.instances.hasOwnProperty(i)) {
                            var instanceName = i;
                            break;
                        }
                    }
                    change++;
                    if (change === 1) {
                        dataLayer.push({
                            'event': 'checkout',
                            'ecommerce': {
                                'currencyCode': 'CHF',
                                'checkout': {
                                    'actionField': {'step': 2},
                                    'products': [{
                                        'name': event.widget.widgetName,
                                        'id': event.widget.id,
                                        'brand': event.widget.widgetUUID,
                                        'category': '',
                                        'variant': '',
                                        'price': '',
                                        'quantity': 1,
                                        'coupon': '',
                                        'position': '',
                                        'dimension1': rnwWidget.widgets.instances[instanceName].get("stored_rnw_product_version")
                                    }]
                                }
                            }
                        });
                    }
                };
                options.widget.on(window.rnwWidget.constants.events.AMOUNT_CHANGED, function (event) {
                    amount = event.value;
                    formChange(event);
                });
                options.widget.on(window.rnwWidget.constants.events.PURPOSE_CHANGED, function (event) {
                    purpose = event.value;
                    formChange(event);
                });
                options.widget.on(window.rnwWidget.constants.events.PAYMENT_METHOD_CHANGED, function (event) {
                    paymentMethod = event.value;
                    formChange(event);
                });
                options.widget.on(window.rnwWidget.constants.events.DONATION_TYPE_CHANGED, function (event) {
                    donationType = event.value;
                    formChange(event);
                });
                options.widget.on(window.rnwWidget.constants.events.INTERVAL_CHANGED, function (event) {
                    interval = event.value;
                    formChange(event);
                });
            }
            ;
            options.widget.on(window.rnwWidget.constants.events.PROCESS_FORM, function (event) {
                for (var i in rnwWidget.widgets.instances) {
                    if (rnwWidget.widgets.instances.hasOwnProperty(i)) {
                        instanceName = i;
                        break;
                    }
                }
                dataLayer.push({
                    'event': 'checkout',
                    'ecommerce': {
                        'currencyCode': 'CHF',
                        'checkout': {
                            'actionField': {'step': 3, 'option': paymentMethod},
                            'products': [{
                                'name': event.widget.widgetName,
                                'id': event.widget.id,
                                'brand': event.widget.widgetUUID,
                                'category': '',
                                'variant': interval,
                                'price': '',
                                'quantity': 1,
                                'coupon': '',
                                'position': '',
                                'dimension1': rnwWidget.widgets.instances[instanceName].get("stored_rnw_product_version")
                            }]
                        }
                    }
                });
            });
            options.widget.on(window.rnwWidget.constants.events.VALIDATION_ERROR, function (event) {
                dataLayer.push({
                    'event': event.type,
                    'widgetName': event.widget.widgetName,
                    'widgetId': event.widget.id,
                    'widgetType': event.widget.widgetUUID,
                    'error': event.error,
                    'errorList': event.errorList
                });
            });
            options.widget.on(window.rnwWidget.constants.events.PAYMENT_COMPLETE, function (event) {
                for (i in rnwWidget.widgets.instances) {
                    if (rnwWidget.widgets.instances.hasOwnProperty(i)) {
                        var instanceName = i;
                        break;
                    }
                }
                var val = (event.payment.amount) / 100;
                if (event.payment.epayment_status === "success") {
                    dataLayer.push({
                        'ecommerce': {
                            'currencyCode': event.currency,
                            'purchase': {
                                'actionField': {
                                    'id': event.payment.epp_transaction_id,
                                    'revenue': val.toFixed(2)
                                },
                                'products': [{
                                    'name': event.widget.widgetName,
                                    'id': event.widget.id,
                                    'price': val.toFixed(2),
                                    'brand': event.widget.widgetUUID,
                                    'category': event.payment.stored_rnw_purpose_text,
                                    'variant': interval,
                                    'quantity': 1,
                                    'coupon': '',
                                    'position': '',
                                    'dimension1': rnwWidget.widgets.instances[instanceName].get("stored_rnw_product_version")
                                }]
                            }
                        },
                        'event': 'transaction'
                    });
                } else {
                    dataLayer.push({
                        'event': 'transaction-error',
                        'name': event.widget.widgetName,
                        'id': event.widget.id,
                        'brand': event.widget.widgetUUID,
                        'dimension1': rnwWidget.widgets.instances[instanceName].get("stored_rnw_product_version")
                    });
                }
            });
        };
    }
});
